// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"65":"thank","353":"contact","594":"about","604":"company"}[chunkId] + "." + {"65":"b787eaba","353":"cad9723a","594":"0160d50a","604":"30bdf26c"}[chunkId] + ".css";
};